export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    id: "faq-1",
    question: "香蕉动漫的资源合集是否免费？",
    answer:
      "是的，香蕉动漫整理的动漫全集资源与资源站目录均可免费浏览。我们致力于让追番与补番变得更加轻松，所有分类、目录与合集信息都会持续整理并免费提供给用户。",
  },
  {
    id: "faq-2",
    question: "资源更新频率是怎样的？",
    answer:
      "香蕉动漫会持续跟进热门连载动漫的更新动态，通常在作品更新后的第一时间同步最新剧集信息，并在资源库中标记『更新中』状态，帮助用户追更不迷路。",
  },
  {
    id: "faq-3",
    question: "如何快速找到自己想看的热门动漫？",
    answer:
      "你可以在资源库中通过顶部搜索框直接输入动漫名称，也可以按『热血冒险』『奇幻魔法』『日常治愈』等分类浏览筛选。我们会为每部作品整理清晰的简介、剧集数量与画质说明，方便你快速决策。",
  },
  {
    id: "faq-4",
    question: "资源库中的高清画质说明可靠吗？",
    answer:
      "资源库中标注的画质信息基于资源站目录整理，具体以实际提供方为准。我们会在详情页中说明资源的来源性质与整理程度，供你在观看前参考。",
  },
  {
    id: "faq-5",
    question: "可以在手机端浏览吗？",
    answer:
      "可以。香蕉动漫采用响应式设计，在电脑、平板与手机上都能获得流畅的浏览体验。移动端菜单支持一键展开与收起，随时随地都能找番追番。",
  },
  {
    id: "faq-6",
    question: "发现资源信息有误该怎么办？",
    answer:
      "如果你发现某个资源的剧集数量、状态或分类信息有误，欢迎通过关于我们页面的联系方式反馈。我们会尽快核实并修正，感谢每一位热心用户的支持。",
  },
];